import { defineComponent as _defineComponent } from 'vue';
import {} from "@vueuse/core";
import { computed } from "vue";
import { useWorkflowStores } from "@/composables/workflowStores";
import { ChangeColorAction, DeleteCommentAction, LazyChangeDataAction, LazyChangePositionAction, LazyChangeSizeAction, ToggleCommentSelectedAction, } from "../Actions/commentActions";
import FrameComment from "./FrameComment.vue";
import FreehandComment from "./FreehandComment.vue";
import MarkdownComment from "./MarkdownComment.vue";
import TextComment from "./TextComment.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowComment',
    props: {
        comment: null,
        scale: null,
        rootOffset: null,
        readonly: { type: Boolean }
    },
    emits: ["pan-by"],
    setup(__props, { emit }) {
        const props = __props;
        const cssVariables = computed(() => ({
            "--position-left": `${props.comment.position[0]}px`,
            "--position-top": `${props.comment.position[1]}px`,
            "--width": `${props.comment.size[0]}px`,
            "--height": `${props.comment.size[1]}px`,
            "--pointer-events": props.comment.type === "freehand" ? "none" : "unset",
        }));
        const { commentStore, undoRedoStore } = useWorkflowStores();
        let lazyAction = null;
        function onUpdateData(data) {
            if (lazyAction instanceof LazyChangeDataAction && undoRedoStore.isQueued(lazyAction)) {
                lazyAction.updateData(data);
            }
            else {
                lazyAction = new LazyChangeDataAction(commentStore, props.comment, data);
                undoRedoStore.applyLazyAction(lazyAction);
            }
        }
        function onResize(size) {
            if (lazyAction instanceof LazyChangeSizeAction && undoRedoStore.isQueued(lazyAction)) {
                lazyAction.updateData(size);
            }
            else {
                lazyAction = new LazyChangeSizeAction(commentStore, props.comment, size);
                undoRedoStore.applyLazyAction(lazyAction);
            }
        }
        function onMove(position) {
            if (lazyAction instanceof LazyChangePositionAction && undoRedoStore.isQueued(lazyAction)) {
                lazyAction.updateData(position);
            }
            else {
                lazyAction = new LazyChangePositionAction(commentStore, props.comment, position);
                undoRedoStore.applyLazyAction(lazyAction);
            }
        }
        function onPan(position) {
            emit("pan-by", position);
        }
        function onRemove() {
            undoRedoStore.applyAction(new DeleteCommentAction(commentStore, props.comment));
        }
        function onSetColor(color) {
            undoRedoStore.applyAction(new ChangeColorAction(commentStore, props.comment, color));
        }
        function toggleSelect(e) {
            if (!props.readonly && !(props.comment.type === "freehand")) {
                if (e.shiftKey) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    undoRedoStore.applyAction(new ToggleCommentSelectedAction(commentStore, props.comment));
                }
            }
        }
        return { __sfc: true, props, emit, cssVariables, commentStore, undoRedoStore, lazyAction, onUpdateData, onResize, onMove, onPan, onRemove, onSetColor, toggleSelect, FrameComment, FreehandComment, MarkdownComment, TextComment };
    }
});
